module.exports = __webpack_public_path__ + "img/brazo-extensor-3.fda42924.png";